/**
 * The languages a candidate can be recorded as speaking.
 *
 * The 22 Eighth Schedule languages plus English, in the spellings the rest of the stack uses.
 * **Must mirror `OpenAIConstants.LANGUAGE_ENUM`** in the backend, which constrains what résumé
 * extraction is allowed to write, and the list in `scripts/backfill-jobseeker-languages.js`.
 *
 * The list is closed, and the editor that consumes it is `freeSolo={false}`, on purpose. This
 * field is filtered by matching the stored value, so "Gujarati" and "Gujrati" are two different
 * answers to the same question and one of them finds nobody. Free text is exactly how
 * `salaryFrequency` ended up with 'monthly', 'Per month' and '' all meaning the same thing, and
 * that field at least had a display map to fall through; this one has a recruiter with a client
 * on the phone.
 *
 * English is first because it is by far the most common; the rest are alphabetical.
 */
export const LANGUAGES: string[] = [
  'English',
  'Assamese',
  'Bengali',
  'Bodo',
  'Dogri',
  'Gujarati',
  'Hindi',
  'Kannada',
  'Kashmiri',
  'Konkani',
  'Maithili',
  'Malayalam',
  'Manipuri',
  'Marathi',
  'Nepali',
  'Odia',
  'Punjabi',
  'Sanskrit',
  'Santali',
  'Sindhi',
  'Tamil',
  'Telugu',
  'Urdu',
];
